import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';

@Injectable({
    providedIn: 'root'
})
export class VisitorObservationService extends ApiService {
    getByVisitors(data: any) {
        return super.post('/visitors-observation/visitors', data);
    }

    getCountDayAndFuture(id: number) {
        return super.get("/visitors-observation/count/day-future/" + id);
    }

    create(data: any) {
        return super.post('/visitors-observation/create', data);
    }

    update(data: any) {
        return super.put('/visitors-observation/update', data);
    }

    delete(id: number) {
        return super.delete('/visitors-observation/' + id);
    }
}
